import React from 'react'
import { useTranslation } from 'react-i18next'
import { EmptyBlock } from 'ui/EmptyBlock/EmptyBlock'
import AddGroupButton from 'pages/training/admin/articles/groups/AddGroupButton/AddGroupButton'

function NoStuffScreen() {
	const { t } = useTranslation()

	return (
		<EmptyBlock
			text={
				<>
					Чтобы добавить сотрудника в Вашу школу
					<br />
					нажмите кнопку "Добавить"
				</>
			}
			button={<AddGroupButton />}
		/>
	)
}

export default NoStuffScreen
